module.exports = __webpack_public_path__ + "img/avatar.c08dad3f.png";